import { FormControl, Textarea } from "@primer/react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { lichSuXuongPhongYTeApi } from "../../api/lichSuXuongPhongYTeApi";
import { hocSinhLichSuYTeTypeApi } from "../../api/hocSinhLichSuYTeTypeApi";
import { hocSinhLichSuYTeSuDungThuocApi } from "../../api/hocSinhLichSuYTeSuDungThuocApi";
import { khoThuocApi } from "../../api/khoThuocApi";
import { IHocSinhLichSuYTeSuDungThuocRequest } from "../../models/request/hoc-sinh/IHocSinhLichSuYTeSuDungThuocRequest";
import { IHocSinhLichSuYTeSuDungThuoc } from "../../models/response/hoc-sinh/IHocSinhLichSuYTeSuDungThuoc";
import { ts_hocsinh_lichsu_yte_khothuoc } from "../../models/response/category/ts_hocsinh_lichsu_yte_khothuoc";
import { loaiThuocApi } from "../../api/loaiThuocApi";
import { donViTinhThuocApi } from "../../api/donViTinhThuocApi";

import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import TextInput from "../../components/ui/text-input";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { ILichSuYteRequest } from "../../models/request/hoc-sinh/ILichSuYteRequest";
import SelectBoxHocSinh from "../../components/selectbox-hocsinh";
import ComboboxLichSuYTeType from "../../components/combobox-lich-su-y-te-type";
import { ComboboxLoaiThuocById } from "../../components/combobox-loai-thuoc/ComboboxLoaiThuocById";
import { ComboboxChuyenKhoa } from "../../components/combobox-chuyen-khoa/ComboboxChuyenKhoa";
import MultiImageUpload from "../../components/multi-image-upload";
import TimeInput24h from "../../components/ui/time-input-24h";

interface ILichSuYTeModalProps {
  id: number;
  onClose: () => void;
  onSuccess: () => void;
  prefilledData?: {
    ts_hocsinh_id: number;
    ho_ten: string;
    ma_hs: string;
    ten_lop: string;
    ten_khoi: string;
    ten_he: string;
    danThuocInfo?: any;
    actionType?: 'confirm' | 'reject'; // Loại hành động: xác nhận hoặc từ chối
  };
}
const LichSuXuongPhongYTeModal = (props: ILichSuYTeModalProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const { dm_coso_id } = useCommonSelectedHook();

  // State cho quản lý sử dụng thuốc
  const [suDungThuocList, setSuDungThuocList] = useState<IHocSinhLichSuYTeSuDungThuoc[]>([]);
  const [originalSuDungThuocList, setOriginalSuDungThuocList] = useState<IHocSinhLichSuYTeSuDungThuoc[]>([]);
  const [selectedLoaiThuocId, setSelectedLoaiThuocId] = useState<string>("");

  // State cho quản lý ngày và giờ riêng biệt
  const [ngayKham, setNgayKham] = useState<string>("");
  const [gioKham, setGioKham] = useState<string>("");
  const [ngayTraVe, setNgayTraVe] = useState<string>("");
  const [gioTraVe, setGioTraVe] = useState<string>("");

  // Hàm helper để tách datetime thành ngày và giờ
  const splitDateTime = (dateTimeString: string) => {
    if (!dateTimeString) return { date: "", time: "" };
    const [date, time] = dateTimeString.split('T');
    return { date: date || "", time: time || "" };
  };

  // Hàm helper để kết hợp ngày và giờ thành datetime string
  const combineDateTime = (date: string, time: string) => {
    if (!date && !time) return "";
    if (!date) return "";
    if (!time) return `${date}T00:00`;
    return `${date}T${time}`;
  };

  // Format datetime string về định dạng local YYYY-MM-DDTHH:mm (không chuyển UTC)
  const toLocalDateTimeMinutes = (dateValue?: string) => {
    if (!dateValue) return "";
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState<ILichSuYteRequest>({
    ts_hocsinh_id: 0,
    ts_hocsinh_lichsu_yte_type_id: 0,
    fa_danthuoc_id: 0,
    dm_trangthai_yte_id: 4, // Mặc định là 1
    tinh_trang: "",
    ket_qua: "",
    images: [],
    ngay_gio_kham: "",
    ngay_gio_tra_ve: "",
    ly_do_xuong_phong_y_te: "",
    xu_tri_y_te_voi_hoc_sinh: "",
    lien_he_phhs: "",
    lien_he_gvcn: "",
    chuyen_co_so_y_te: "",
    truong_hop_dac_biet: "",
    loai_thuoc: "",
    chuyenkhoa_id: "",
  });

  const {
    handleSubmit,
    clearErrors,
    reset,
    setError,
    control,
    setValue,
    formState: { errors },
  } = useForm<ILichSuYteRequest>({
    mode: "onChange", // Validate khi người dùng thay đổi input
    reValidateMode: "onChange", // Re-validate khi có thay đổi
    defaultValues: formData,
  });

  useEffect(() => {
    if (props.id > 0) {
      handleGetVm();
      loadSuDungThuocList(props.id, true); // true = initial load
    } else if (props.prefilledData) {
      // Nếu có prefilledData, tìm hoặc tạo loại "Dặn thuốc"
      handleGetOrCreateDanThuocType();
    }
  }, [props.id, props.prefilledData]);

  // Cập nhật ngày giờ khám và tình trạng mỗi khi modal mở cho xác nhận/từ chối dặn thuốc
  useEffect(() => {
    if (props.prefilledData && !props.id) {
      // Chỉ cập nhật khi là modal mới (không phải edit) và có prefilledData
      const now = new Date();
      // Lấy thời gian địa phương và format cho datetime-local input
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const currentDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
      setValue("ngay_gio_kham", currentDateTime);

      // Cập nhật state ngày giờ riêng biệt
      setNgayKham(`${year}-${month}-${day}`);
      setGioKham(`${hours}:${minutes}`);

      // Cập nhật tình trạng với ngày hiện tại dựa trên actionType
      const currentDate = now.toLocaleDateString('vi-VN');
      const actionType = props.prefilledData.actionType || 'confirm';
      const isReject = actionType === 'reject';

      setValue("tinh_trang", isReject
        ? `Từ chối cho uống thuốc ${currentDate}`
        : `Xác nhận cho uống thuốc ${currentDate}`);

      // Cập nhật trạng thái y tế
      setValue("dm_trangthai_yte_id", isReject ? 5 : 4);
    }
  }, [props.prefilledData, props.id, setValue]);

  const handleGetOrCreateDanThuocType = async () => {
    try {
      // Lấy danh sách loại lịch sử y tế
      const res = await hocSinhLichSuYTeTypeApi.selectAll();
      if (res.is_success) {
        let danThuocTypeId = 0;
        const danThuocType = res.data.find((type: any) => type.nhom_noi_dung === "Dặn thuốc");

        if (danThuocType) {
          danThuocTypeId = danThuocType.id;
        } else {
          // Tạo mới loại "Dặn thuốc" nếu chưa có
          const createRes = await hocSinhLichSuYTeTypeApi.insert({
            id: 0,
            nhom_noi_dung: "Dặn thuốc",
            nhom_noi_dung_en: "Medicine Administration"
          });
          if (createRes.is_success) {
            danThuocTypeId = createRes.data.id;
          }
        }

        // Set dữ liệu mặc định dựa trên actionType
        const actionType = props.prefilledData!.actionType || 'confirm';
        const isReject = actionType === 'reject';
        const fa_danthuoc_id = props.prefilledData!.danThuocInfo?.id || 0;

        const defaultData: ILichSuYteRequest = {
          ts_hocsinh_id: props.prefilledData!.ts_hocsinh_id,
          ts_hocsinh_lichsu_yte_type_id: danThuocTypeId,
          fa_danthuoc_id: fa_danthuoc_id, // Lưu ID của dặn thuốc
          dm_trangthai_yte_id: isReject ? 5 : 4, // Set trạng thái y tế = 5 cho từ chối, 4 cho xác nhận
          tinh_trang: isReject ? "Từ chối cho uống thuốc" : "Đã cho uống thuốc",
          ket_qua: "",
          images: [],
          ngay_gio_kham: (() => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
          })(), // Ngày giờ hiện tại địa phương
          ngay_gio_tra_ve: "",
          ly_do_xuong_phong_y_te: isReject
            ? `Từ chối cho uống thuốc ${new Date().toLocaleDateString('vi-VN')}`
            : `Xác nhận cho uống thuốc ${new Date().toLocaleDateString('vi-VN')}`,
          xu_tri_y_te_voi_hoc_sinh: props.prefilledData!.danThuocInfo?.chiTiets?.map((ct: any) => `${ct.ten_thuoc}: ${ct.cachdung_lieuluong}`).join('\n') || "",
          lien_he_phhs: "",
          lien_he_gvcn: "",
          chuyen_co_so_y_te: "",
          truong_hop_dac_biet: "",
          loai_thuoc: "",
          chuyenkhoa_id: "",
        };

        // Tách ngày giờ khám cho prefilledData
        const ngayGioKhamSplit = splitDateTime(defaultData.ngay_gio_kham || "");
        setNgayKham(ngayGioKhamSplit.date);
        setGioKham(ngayGioKhamSplit.time);

        setFormData(defaultData);
        reset(defaultData);
      }
    } catch (error) {
      console.error("Error getting or creating dan thuoc type:", error);
    }
  };

  const handleGetVm = async () => {
    const res = await lichSuXuongPhongYTeApi.selectById(props.id);
    if (res.is_success) {
      const responseData = res.data;
      const data: ILichSuYteRequest = {
        id: props.id,
        ts_hocsinh_id: responseData.lichSuYTe?.ts_hocsinh_id || responseData.ts_hocsinh_id,
        ts_hocsinh_lichsu_yte_type_id: responseData.lichSuYTe?.ts_hocsinh_lichsu_yte_type_id || responseData.ts_hocsinh_lichsu_yte_type_id,
        fa_danthuoc_id: responseData.lichSuYTe?.fa_danthuoc_id || responseData.fa_danthuoc_id || 0,
        dm_trangthai_yte_id: responseData.lichSuYTe?.dm_trangthai_yte_id || responseData.dm_trangthai_yte_id || 4,
        tinh_trang: responseData.lichSuYTe?.tinh_trang || responseData.tinh_trang,
        ket_qua: responseData.lichSuYTe?.ket_qua || responseData.ket_qua,
        images: responseData.images || [],
        ngay_gio_kham: responseData.lichSuYTe?.ngay_gio_kham
          ? toLocalDateTimeMinutes(responseData.lichSuYTe.ngay_gio_kham)
          : (responseData.ngay_gio_kham ? toLocalDateTimeMinutes(responseData.ngay_gio_kham) : ""),
        ngay_gio_tra_ve: responseData.lichSuYTe?.ngay_gio_tra_ve
          ? toLocalDateTimeMinutes(responseData.lichSuYTe.ngay_gio_tra_ve)
          : (responseData.ngay_gio_tra_ve ? toLocalDateTimeMinutes(responseData.ngay_gio_tra_ve) : ""),
        ly_do_xuong_phong_y_te: responseData.lichSuYTe?.ly_do_xuong_phong_y_te || responseData.ly_do_xuong_phong_y_te || "",
        xu_tri_y_te_voi_hoc_sinh: responseData.lichSuYTe?.xu_tri_y_te_voi_hoc_sinh || responseData.xu_tri_y_te_voi_hoc_sinh || "",
        lien_he_phhs: responseData.lichSuYTe?.lien_he_phhs || responseData.lien_he_phhs || "",
        lien_he_gvcn: responseData.lichSuYTe?.lien_he_gvcn || responseData.lien_he_gvcn || "",
        chuyen_co_so_y_te: responseData.lichSuYTe?.chuyen_co_so_y_te || responseData.chuyen_co_so_y_te || "",
        truong_hop_dac_biet: responseData.lichSuYTe?.truong_hop_dac_biet || responseData.truong_hop_dac_biet || "",
        loai_thuoc: responseData.lichSuYTe?.loai_thuoc || responseData.loai_thuoc || "",
        chuyenkhoa_id: responseData.lichSuYTe?.chuyenkhoa_id?.toString() || responseData.chuyenkhoa_id?.toString() || "",
      };

      // Tách ngày giờ khám
      const ngayGioKhamSplit = splitDateTime(data.ngay_gio_kham || "");
      setNgayKham(ngayGioKhamSplit.date);
      setGioKham(ngayGioKhamSplit.time);

      // Tách ngày giờ trả về
      const ngayGioTraVeSplit = splitDateTime(data.ngay_gio_tra_ve || "");
      setNgayTraVe(ngayGioTraVeSplit.date);
      setGioTraVe(ngayGioTraVeSplit.time);

      setFormData(data);
      reset(data);
    } else {
      NotifyHelper.Error(res.message ?? "Error");
    }
  };

  // Hàm load danh sách sử dụng thuốc
  const loadSuDungThuocList = async (lichSuYTeId: number, isInitialLoad: boolean = false) => {
    try {
      const res = await hocSinhLichSuYTeSuDungThuocApi.selectByLichSuYTeId(lichSuYTeId);
      if (res.is_success) {
        // Load tên thuốc và đơn vị tính cho từng item
        const listWithTenThuocAndDonViTinh = await Promise.all((res.data || []).map(async (item: any) => {
          try {
            const loaiThuocRes = await loaiThuocApi.detail(item.ts_hocsinh_lichsu_yte_loaithuoc_id);
            let tenThuoc = "Không xác định";
            let tenDonViTinh = "Không xác định";

            if (loaiThuocRes.is_success) {
              tenThuoc = loaiThuocRes.data.ten_thuoc;

              // Load đơn vị tính nếu có
              if (loaiThuocRes.data.ts_hocsinh_lichsu_yte_donvitinh_id) {
                try {
                  const donViTinhRes = await donViTinhThuocApi.detail(loaiThuocRes.data.ts_hocsinh_lichsu_yte_donvitinh_id);
                  if (donViTinhRes.is_success) {
                    tenDonViTinh = donViTinhRes.data.ten_donvitinh;
                  }
                } catch {
                  tenDonViTinh = "Không xác định";
                }
              }
            }

            return {
              ...item,
              ten_thuoc: tenThuoc,
              ten_donvitinh: tenDonViTinh
            };
          } catch {
            return {
              ...item,
              ten_thuoc: "Không xác định",
              ten_donvitinh: "Không xác định"
            };
          }
        }));
        setSuDungThuocList(listWithTenThuocAndDonViTinh);
        // Chỉ lưu danh sách ban đầu khi load modal lần đầu
        if (isInitialLoad) {
          setOriginalSuDungThuocList(listWithTenThuocAndDonViTinh);
        }
      }
    } catch (error) {
      console.error("Error loading su dung thuoc list:", error);
    }
  };

  // Hàm thêm thuốc vào bảng
  const handleAddThuoc = async (loaiThuocId: number) => {
    if (!loaiThuocId || loaiThuocId === 0) {
      NotifyHelper.Error("Vui lòng chọn loại thuốc");
      return;
    }

    // Kiểm tra xem thuốc đã có trong danh sách chưa
    const existingThuoc = suDungThuocList.find(item => item.ts_hocsinh_lichsu_yte_loaithuoc_id === loaiThuocId);
    if (existingThuoc) {
      NotifyHelper.Error("Loại thuốc này đã được thêm vào danh sách");
      return;
    }

    if (props.id > 0) {
      // Nếu đang edit, thêm vào database ngay
      try {
        const request: IHocSinhLichSuYTeSuDungThuocRequest = {
          ts_hocsinh_lichsu_yte_id: props.id,
          ts_hocsinh_lichsu_yte_loaithuoc_id: loaiThuocId,
          lieu_luong: "",
          ghi_chu: ""
        };

        const res = await hocSinhLichSuYTeSuDungThuocApi.insert(request);
        if (res.is_success) {
          await loadSuDungThuocList(props.id);
          NotifyHelper.Success("Thêm thuốc thành công");
        } else {
          NotifyHelper.Error(res.message ?? "Có lỗi xảy ra khi thêm thuốc");
        }
      } catch (error) {
        NotifyHelper.Error("Có lỗi xảy ra khi thêm thuốc");
      }
    } else {
      // Nếu đang tạo mới, thêm vào state tạm thời
      try {
        const loaiThuocRes = await loaiThuocApi.detail(loaiThuocId);
        let tenThuoc = "Không xác định";
        let tenDonViTinh = "Không xác định";

        if (loaiThuocRes.is_success) {
          tenThuoc = loaiThuocRes.data.ten_thuoc;

          // Load đơn vị tính nếu có
          if (loaiThuocRes.data.ts_hocsinh_lichsu_yte_donvitinh_id) {
            try {
              const donViTinhRes = await donViTinhThuocApi.detail(loaiThuocRes.data.ts_hocsinh_lichsu_yte_donvitinh_id);
              if (donViTinhRes.is_success) {
                tenDonViTinh = donViTinhRes.data.ten_donvitinh;
              }
            } catch {
              tenDonViTinh = "Không xác định";
            }
          }
        }

        const newItem: IHocSinhLichSuYTeSuDungThuoc = {
          id: Date.now(), // Temporary ID
          ts_hocsinh_lichsu_yte_id: 0,
          ts_hocsinh_lichsu_yte_loaithuoc_id: loaiThuocId,
          lieu_luong: "",
          ghi_chu: "",
          ten_thuoc: tenThuoc,
          ten_donvitinh: tenDonViTinh
        };
        setSuDungThuocList([...suDungThuocList, newItem]);
      } catch (error) {
        const newItem: IHocSinhLichSuYTeSuDungThuoc = {
          id: Date.now(), // Temporary ID
          ts_hocsinh_lichsu_yte_id: 0,
          ts_hocsinh_lichsu_yte_loaithuoc_id: loaiThuocId,
          lieu_luong: "",
          ghi_chu: "",
          ten_thuoc: "Không xác định",
          ten_donvitinh: "Không xác định"
        };
        setSuDungThuocList([...suDungThuocList, newItem]);
      }
    }
  };

  // Hàm xóa thuốc
  const handleDeleteThuoc = async (item: IHocSinhLichSuYTeSuDungThuoc) => {
    if (props.id > 0 && item.id > 0) {
      // Nếu đang edit và item đã có trong database
      try {
        const res = await hocSinhLichSuYTeSuDungThuocApi.delete(item.id);
        if (res.is_success) {
          await loadSuDungThuocList(props.id);
          NotifyHelper.Success("Xóa thuốc thành công");
        } else {
          NotifyHelper.Error(res.message ?? "Có lỗi xảy ra khi xóa thuốc");
        }
      } catch (error) {
        NotifyHelper.Error("Có lỗi xảy ra khi xóa thuốc");
      }
    } else {
      // Xóa khỏi state tạm thời
      setSuDungThuocList(suDungThuocList.filter(x => x.id !== item.id));
    }
  };

  // Hàm cập nhật liều lượng và ghi chú
  const handleUpdateThuoc = async (item: IHocSinhLichSuYTeSuDungThuoc, field: 'lieu_luong' | 'ghi_chu', value: string) => {
    if (props.id > 0 && item.id > 0) {
      // Nếu đang edit và item đã có trong database
      try {
        const request: IHocSinhLichSuYTeSuDungThuocRequest = {
          ts_hocsinh_lichsu_yte_id: props.id,
          ts_hocsinh_lichsu_yte_loaithuoc_id: item.ts_hocsinh_lichsu_yte_loaithuoc_id,
          lieu_luong: field === 'lieu_luong' ? value : item.lieu_luong,
          ghi_chu: field === 'ghi_chu' ? value : item.ghi_chu
        };

        const res = await hocSinhLichSuYTeSuDungThuocApi.update(item.id, request);
        if (res.is_success) {
          await loadSuDungThuocList(props.id);
        }
      } catch (error) {
        console.error("Error updating thuoc:", error);
      }
    } else {
      // Cập nhật state tạm thời
      const updatedList = suDungThuocList.map(x =>
        x.id === item.id ? { ...x, [field]: value } : x
      );
      setSuDungThuocList(updatedList);
    }
  };

  // Hàm lấy danh sách bản ghi kho thuốc đã tạo cho lịch sử y tế này
  const getKhoThuocRecordsByLichSuYTeId = async (lichSuYTeId: number) => {
    try {
      const response = await khoThuocApi.selectAllLichSu();
      if (response.is_success) {
        // Filter các bản ghi có ghi chú chứa ID lịch sử y tế này
        const records = (response.data || []).filter((item: any) =>
          item.ghi_chu && item.ghi_chu.includes(`lịch sử y tế ID: ${lichSuYTeId}`) &&
          item.loai_giao_dich === "XUAT" &&
          item.dm_coso_id === dm_coso_id
        );
        return records;
      }
    } catch (error) {
      console.error('Error loading kho thuoc records:', error);
    }
    return [];
  };

  // Hàm xử lý thay đổi thuốc khi cập nhật
  // Logic mới: Cập nhật trực tiếp bản ghi XUẤT đã có thay vì tạo nhiều bản ghi mới
  const handleThuocChangesOnUpdate = async (lichSuYTeId: number) => {
    try {
      // 1. Lấy danh sách bản ghi kho thuốc đã tạo cho lịch sử y tế này
      const existingKhoThuocRecords = await getKhoThuocRecordsByLichSuYTeId(lichSuYTeId);

      // 2. Xử lý từng thuốc trong danh sách hiện tại
      for (const currentThuoc of suDungThuocList) {
        const existingRecord = existingKhoThuocRecords.find((record: any) =>
          record.ts_hocsinh_lichsu_yte_loaithuoc_id === currentThuoc.ts_hocsinh_lichsu_yte_loaithuoc_id
        );

        const newQuantity = parseFloat(currentThuoc.lieu_luong) || 1;

        if (existingRecord) {
          // Cập nhật bản ghi đã có
          const updateData = {
            ...existingRecord,
            so_luong: newQuantity,
            ghi_chu: `Xuất thuốc cho lịch sử y tế ID: ${lichSuYTeId} (cập nhật)`,
            last_modified_times: new Date().toISOString(),
            last_modified_user_id: 0
          };
          await khoThuocApi.update(updateData);
        } else {
          // Tạo bản ghi mới cho thuốc mới thêm
          const newRecord: ts_hocsinh_lichsu_yte_khothuoc = {
            id: 0,
            ts_hocsinh_lichsu_yte_loaithuoc_id: currentThuoc.ts_hocsinh_lichsu_yte_loaithuoc_id,
            loai_giao_dich: "XUAT",
            so_luong: newQuantity,
            hsd: "",
            ghi_chu: `Xuất thuốc cho lịch sử y tế ID: ${lichSuYTeId}`,
            dm_coso_id: dm_coso_id,
            is_deleted: false,
            created_time: new Date().toISOString(),
            created_user_id: 0,
            last_modified_times: new Date().toISOString(),
            last_modified_user_id: 0
          };
          await khoThuocApi.insert(newRecord);
        }
      }

      // 3. Xóa các bản ghi kho thuốc của thuốc không còn sử dụng
      for (const existingRecord of existingKhoThuocRecords) {
        const stillUsed = suDungThuocList.some(thuoc =>
          thuoc.ts_hocsinh_lichsu_yte_loaithuoc_id === existingRecord.ts_hocsinh_lichsu_yte_loaithuoc_id
        );

        if (!stillUsed) {
          await khoThuocApi.delete(existingRecord.id);
        }
      }
    } catch (error) {
      console.error('Lỗi khi xử lý thay đổi thuốc:', error);
    }
  };

  const onSubmit = async (data: any) => {
    // Validate toàn bộ form trước khi submit
    const validationErrors: any = {};
    debugger
    // Validate học sinh
    if (!data.ts_hocsinh_id || data.ts_hocsinh_id === 0) {
      validationErrors.ts_hocsinh_id = "Vui lòng chọn học sinh";
    }
    // Validate loại lịch sử y tế
    if (!data.ts_hocsinh_lichsu_yte_type_id || data.ts_hocsinh_lichsu_yte_type_id === 0) {
      validationErrors.ts_hocsinh_lichsu_yte_type_id = "Vui lòng chọn loại lịch sử y tế";
    }
    // Validate tình trạng
    if (!data.tinh_trang || data.tinh_trang.trim() === "") {
      validationErrors.tinh_trang = "Vui lòng điền tình trạng";
    }

    // Nếu có lỗi validation, hiển thị lỗi và dừng submit
    if (Object.keys(validationErrors).length > 0) {
      Object.keys(validationErrors).forEach(field => {
        setError(field as any, {
          type: "manual",
          message: validationErrors[field]
        });
      });
      NotifyHelper.Error("Vui lòng kiểm tra lại thông tin đã nhập");
      return;
    }

    setIsSaving(true);
    try {
      // Kết hợp ngày và giờ trước khi submit
      const finalData = {
        ...data,
        ngay_gio_kham: combineDateTime(ngayKham, gioKham),
        ngay_gio_tra_ve: combineDateTime(ngayTraVe, gioTraVe)
      };

      let res: any;
      if (props.id > 0) {
        res = await lichSuXuongPhongYTeApi.update({
          ...finalData,
          id: props.id,
        });
      } else {
        res = await lichSuXuongPhongYTeApi.insert({
          ...finalData
        });
      }

      if (res.is_success) {
        // Xử lý thuốc cho cả tạo mới và cập nhật
        if (props.id > 0) {
          // Cập nhật: xử lý thay đổi thuốc
          await handleThuocChangesOnUpdate(props.id);
        } else if (suDungThuocList.length > 0) {
          // Tạo mới: lưu danh sách sử dụng thuốc
          const lichSuYTeId = res.data.id;
          for (const item of suDungThuocList) {
            // 1. Lưu bản ghi sử dụng thuốc
            const request: IHocSinhLichSuYTeSuDungThuocRequest = {
              ts_hocsinh_lichsu_yte_id: lichSuYTeId,
              ts_hocsinh_lichsu_yte_loaithuoc_id: item.ts_hocsinh_lichsu_yte_loaithuoc_id,
              lieu_luong: item.lieu_luong,
              ghi_chu: item.ghi_chu
            };
            await hocSinhLichSuYTeSuDungThuocApi.insert(request);

            // 2. Tự động tạo bản ghi xuất thuốc trong kho
            try {
              const khoThuocData: ts_hocsinh_lichsu_yte_khothuoc = {
                id: 0,
                ts_hocsinh_lichsu_yte_loaithuoc_id: item.ts_hocsinh_lichsu_yte_loaithuoc_id,
                loai_giao_dich: "XUAT",
                so_luong: parseFloat(item.lieu_luong) || 1, // Chuyển liều lượng thành số lượng
                hsd: "",
                ghi_chu: `Xuất thuốc cho lịch sử y tế ID: ${lichSuYTeId}`,
                dm_coso_id: dm_coso_id,
                is_deleted: false,
                created_time: new Date().toISOString(),
                created_user_id: 0,
                last_modified_times: new Date().toISOString(),
                last_modified_user_id: 0
              };
              await khoThuocApi.insert(khoThuocData);
            } catch (khoError) {
              console.error('Lỗi khi tạo bản ghi xuất thuốc:', khoError);
              // Không throw error để không ảnh hưởng đến việc lưu lịch sử y tế
            }
          }
        }

        NotifyHelper.Success(props.id > 0 ? "Cập nhật thành công" : "Thêm mới thành công");
        props.onSuccess();
      } else {
        NotifyHelper.Error(res.message ?? "Có lỗi xảy ra khi lưu dữ liệu");
      }
    } catch (error) {
      NotifyHelper.Error("Có lỗi xảy ra khi lưu dữ liệu");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      sx={{
        width: "900px",
        maxHeight: "95vh"
      }}
      title={props.id > 0 ? "Cập nhật lịch sử y tế" : "Thêm mới lịch sử y tế"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row" style={{ margin: 0 }}>
          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Học sinh</FormControl.Label>
              <Controller
                name="ts_hocsinh_id"
                control={control}
                rules={{
                  required: "Vui lòng chọn học sinh",
                  validate: (value) => {
                    if (!value || value === 0) {
                      return "Vui lòng chọn học sinh";
                    }
                    return true;
                  }
                }}
                render={({ field }) => (
                  props.prefilledData ? (
                    <TextInput
                                        block

                      value={`${props.prefilledData.ma_hs} - ${props.prefilledData.ho_ten} (${props.prefilledData.ten_lop})`}
                      disabled
                      sx={{ backgroundColor: "canvas.subtle" }}
                    />
                  ) : (
                    <SelectBoxHocSinh
                      isReadonly={false}
                      value={field.value}
                      onValueChanged={(value) => {
                        field.onChange(value);
                        clearErrors("ts_hocsinh_id");
                      }}
                    />
                  )
                )}
              />
              {errors.ts_hocsinh_id && (
                <FormControl.Validation variant="error">
                  {errors.ts_hocsinh_id.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>
          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Loại lịch sử y tế</FormControl.Label>
              <Controller
                name="ts_hocsinh_lichsu_yte_type_id"
                control={control}
                rules={{
                  required: "Vui lòng chọn loại lịch sử y tế",
                  validate: (value) => {
                    if (!value || value === 0) {
                      return "Vui lòng chọn loại lịch sử y tế";
                    }
                    return true;
                  }
                }}
                render={({ field }) => (
                  props.prefilledData ? (
                    <TextInput
                                        block

                      value="Dặn thuốc"
                      disabled
                      sx={{ backgroundColor: "canvas.subtle" }}
                    />
                  ) : (
                    <ComboboxLichSuYTeType
                      value={field.value}
                      onValueChanged={(value) => {
                        field.onChange(value);
                        clearErrors("ts_hocsinh_lichsu_yte_type_id");
                      }}
                    />
                  )
                )}
              />
              {errors.ts_hocsinh_lichsu_yte_type_id && (
                <FormControl.Validation variant="error">
                  {errors.ts_hocsinh_lichsu_yte_type_id.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>
         
          {/* Kết quả field is hidden */}

          {/* Thông tin thời gian */}
          <div className="col-md-12 mb-1">
            <h6 style={{ color: "#0969da", borderBottom: "1px solid #d1d9e0", paddingBottom: "4px", marginBottom: "8px", fontSize: "14px" }}>
              Thông tin thời gian
            </h6>
          </div>

          <div className="col-md-3 mb-2">
            <FormControl>
              <FormControl.Label>Ngày khám</FormControl.Label>
              <TextInput
                type="date"
                block
                value={ngayKham}
                onChange={(e) => {
                  setNgayKham(e.target.value);
                  const combinedDateTime = combineDateTime(e.target.value, gioKham);
                  setValue("ngay_gio_kham", combinedDateTime);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-3 mb-2">
            <FormControl>
              <FormControl.Label>Giờ khám (24h)</FormControl.Label>
              <TimeInput24h
                block
                value={gioKham}
                onChange={(value) => {
                  setGioKham(value);
                  const combinedDateTime = combineDateTime(ngayKham, value);
                  setValue("ngay_gio_kham", combinedDateTime);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-3 mb-2">
            <FormControl>
              <FormControl.Label>Ngày trả về</FormControl.Label>
              <TextInput
                type="date"
                block
                value={ngayTraVe}
                onChange={(e) => {
                  setNgayTraVe(e.target.value);
                  const combinedDateTime = combineDateTime(e.target.value, gioTraVe);
                  setValue("ngay_gio_tra_ve", combinedDateTime);
                }}
              />
            </FormControl>
          </div>

          <div className="col-md-3 mb-2">
            <FormControl>
              <FormControl.Label>Giờ trả về (24h)</FormControl.Label>
              <TimeInput24h
                block
                value={gioTraVe}
                onChange={(value) => {
                  setGioTraVe(value);
                  const combinedDateTime = combineDateTime(ngayTraVe, value);
                  setValue("ngay_gio_tra_ve", combinedDateTime);
                }}
              />
            </FormControl>
          </div>

          {/* Thông tin chi tiết */}
          <div className="col-md-12 mb-1">
            <h6 style={{ color: "#0969da", borderBottom: "1px solid #d1d9e0", paddingBottom: "4px", marginBottom: "8px", fontSize: "14px" }}>
              Thông tin chi tiết
            </h6>
          </div>

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Lý do xuống phòng y tế</FormControl.Label>
              <Controller
                name="ly_do_xuong_phong_y_te"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập lý do xuống phòng y tế..."
                    disabled={!!props.prefilledData}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>
           <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Tình trạng</FormControl.Label>
              <Controller
                name="tinh_trang"
                control={control}
                rules={{
                  required: "Vui lòng nhập tình trạng",
                  validate: (value) => {
                    if (!value) {
                      return "Vui lòng nhập tình trạng";
                    }
                    return true;
                  }
                }}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập tình trạng..."
                    disabled={!!props.prefilledData} // Disabled khi xác nhận dặn thuốc
                    sx={props.prefilledData ? { backgroundColor: "canvas.subtle" } : {}}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      clearErrors("tinh_trang");
                    }}
                  />
                )}
              />
              {errors.tinh_trang && (
                <FormControl.Validation variant="error">
                  {errors.tinh_trang.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>

          <div className="col-md-12 mb-2">
            <FormControl>
              <FormControl.Label>Xử trí y tế với học sinh</FormControl.Label>
              <Controller
                name="xu_tri_y_te_voi_hoc_sinh"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập xử trí y tế với học sinh..."
                    disabled={!!props.prefilledData}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>
          {/* Quản lý sử dụng thuốc */}
          <div className="col-md-12 mb-2">
            <h6 style={{ color: "#0969da", borderBottom: "1px solid #d1d9e0", paddingBottom: "4px", marginBottom: "8px", fontSize: "14px" }}>
              Quản lý sử dụng thuốc
            </h6>
          </div>

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Loại thuốc</FormControl.Label>
              <ComboboxLoaiThuocById
                value={selectedLoaiThuocId}
                onValueChanged={(value) => {
                  if (value && value !== "") {
                    handleAddThuoc(parseInt(value));
                  }
                  setSelectedLoaiThuocId("");
                }}
                isShowClearButton={true}
              />
            </FormControl>
          </div>
<div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Chuyên khoa</FormControl.Label>
              <Controller
                name="chuyenkhoa_id"
                control={control}
                render={({ field }) => (
                  <ComboboxChuyenKhoa
                    value={field.value || ""}
                    onValueChanged={(value) => {
                      field.onChange(value);
                    }}
                    isShowClearButton={true}
                  />
                )}
              />
            </FormControl>
          </div>
          {/* Bảng danh sách sử dụng thuốc */}
          {suDungThuocList.length > 0 && (
            <div className="col-md-12 mb-2">
              <div style={{
                border: "1px solid #d1d9e0",
                borderRadius: "6px",
                overflow: "hidden",
                backgroundColor: "#fff"
              }}>
                <table className="table mb-0" style={{ fontSize: "13px" }}>
                  <thead style={{ backgroundColor: "#f6f8fa", borderBottom: "1px solid #d1d9e0" }}>
                    <tr>
                      <th style={{
                        width: "30%",
                        padding: "10px 12px",
                        fontWeight: "600",
                        color: "#24292f",
                        borderRight: "1px solid #d1d9e0"
                      }}>
                        Loại thuốc
                      </th>
                      <th style={{
                        width: "15%",
                        padding: "10px 12px",
                        fontWeight: "600",
                        color: "#24292f",
                        borderRight: "1px solid #d1d9e0"
                      }}>
                        Đơn vị tính
                      </th>
                      <th style={{
                        width: "20%",
                        padding: "10px 12px",
                        fontWeight: "600",
                        color: "#24292f",
                        borderRight: "1px solid #d1d9e0"
                      }}>
                        Liều lượng
                      </th>
                      <th style={{
                        width: "25%",
                        padding: "10px 12px",
                        fontWeight: "600",
                        color: "#24292f",
                        borderRight: "1px solid #d1d9e0"
                      }}>
                        Ghi chú
                      </th>
                      <th style={{
                        padding: "10px 12px",
                        fontWeight: "600",
                        color: "#24292f",
                        textAlign: "center"
                      }}>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {suDungThuocList.map((item, index) => (
                      <tr key={item.id || index} style={{ borderBottom: index < suDungThuocList.length - 1 ? "1px solid #d1d9e0" : "none" }}>
                        <td style={{
                          padding: "10px 12px",
                          verticalAlign: "middle",
                          borderRight: "1px solid #d1d9e0",
                          color: "#24292f",
                          fontWeight: "500"
                        }}>
                          {item.ten_thuoc || "Đang tải..."}
                        </td>
                        <td style={{
                          padding: "10px 12px",
                          verticalAlign: "middle",
                          borderRight: "1px solid #d1d9e0",
                          color: "#24292f",
                          fontSize: "13px"
                        }}>
                          {item.ten_donvitinh || "Không xác định"}
                        </td>
                        <td style={{
                          padding: "8px 12px",
                          borderRight: "1px solid #d1d9e0"
                        }}>
                          <TextInput
                            block
                            size="small"
                            type="number"
                            min="0"
                            step="0.1"
                            value={item.lieu_luong || ""}
                            onChange={(e) => handleUpdateThuoc(item, 'lieu_luong', e.target.value)}
                            placeholder="Nhập liều lượng..."
                            style={{ fontSize: "13px" }}
                          />
                        </td>
                        <td style={{
                          padding: "8px 12px",
                          borderRight: "1px solid #d1d9e0"
                        }}>
                          <TextInput
                            block
                            size="small"
                            value={item.ghi_chu || ""}
                            onChange={(e) => handleUpdateThuoc(item, 'ghi_chu', e.target.value)}
                            placeholder="Nhập ghi chú..."
                            style={{ fontSize: "13px" }}
                          />
                        </td>
                        <td style={{
                          padding: "8px 12px",
                          textAlign: "center",
                          verticalAlign: "middle"
                        }}>
                          <Button
                            text="×"
                            variant="danger"
                            size="small"
                            onClick={() => handleDeleteThuoc(item)}
                            style={{
                              minWidth: "28px",
                              height: "28px",
                              padding: "0",
                              fontSize: "16px",
                              fontWeight: "bold"
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          

          {/* Thông tin liên hệ */}
          <div className="col-md-12 mb-1">
            <h6 style={{ color: "#0969da", borderBottom: "1px solid #d1d9e0", paddingBottom: "4px", marginBottom: "8px", fontSize: "14px" }}>
              Thông tin liên hệ
            </h6>
          </div>

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Liên hệ PHHS</FormControl.Label>
              <Controller
                name="lien_he_phhs"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập thông tin liên hệ phụ huynh học sinh..."
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Liên hệ GVCN</FormControl.Label>
              <Controller
                name="lien_he_gvcn"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập thông tin liên hệ giáo viên chủ nhiệm..."
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>

          {/* Thông tin đặc biệt */}
          <div className="col-md-12 mb-1">
            <h6 style={{ color: "#0969da", borderBottom: "1px solid #d1d9e0", paddingBottom: "4px", marginBottom: "8px", fontSize: "14px" }}>
              Thông tin đặc biệt
            </h6>
          </div>

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Chuyển cơ sở y tế</FormControl.Label>
              <Controller
                name="chuyen_co_so_y_te"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập thông tin chuyển cơ sở y tế..."
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>

         

          <div className="col-md-6 mb-2">
            <FormControl>
              <FormControl.Label>Trường hợp đặc biệt</FormControl.Label>
              <Controller
                name="truong_hop_dac_biet"
                control={control}
                render={({ field }) => (
                  <Textarea
                    {...field}
                    rows={2}
                    block
                    placeholder="Nhập thông tin trường hợp đặc biệt..."
                    onChange={(e) => {
                      field.onChange(e.target.value);
                    }}
                  />
                )}
              />
            </FormControl>
          </div>

          <div className="col-md-12 mb-2">
            <FormControl>
              <FormControl.Label>Hình ảnh</FormControl.Label>
              <Controller
                name="images"
                control={control}
                render={({ field }) => (
                  <MultiImageUpload
                    value={field.value || []}
                    onValueChanged={(images) => {
                      field.onChange(images);
                    }}
                    maxImages={10}
                    lichSuYTeId={props.id > 0 ? props.id : undefined}
                  />
                )}
              />
            </FormControl>
          </div>
        </div>

        <ModalActions>
          <Button text="Base.Label.Close" onClick={props.onClose} />
          <Button
            text="Base.Label.Save"
            variant="primary"
            type="submit"
            isLoading={isSaving}
            disabled={isSaving}
          />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default LichSuXuongPhongYTeModal;
